import React from 'react'
import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { Form } from 'react-bootstrap'

export default function DatePicker(props) {

    const { label_name, placeholder, name, value, onChange, onBlur, error, mandatory, reference, tabIndex } = props
    return (
        <>
            <Form.Group className="mb-3" controlId="date">
                <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{label_name}</Form.Label>
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                // Input field styles
                                borderRadius: 6,
                                borderColor: '#323c4c',
                                colorBgContainer: '#323c4c',   // Input background
                                colorText: '#fff',             // Input text
                                colorTextPlaceholder: '#fff',  // Placeholder text
                                hoverBorderColor: '#42c9c4',   // Border on hover
                                activeBorderColor: '#42c9c4',  // Border on focus
                                zIndexPopup: 99999,

                                // Calendar popup styles
                                colorBgElevated: '#323c4c',    // Calendar background
                                colorTextHeading: '#fff',      // Month/Year text
                                colorText: '#fff',             // Normal text
                                colorTextDescription: '#fff',  // Dates from other months
                                colorTextDisabled: '#aaa',     // Disabled dates
                                colorIcon: '#fff',             // Arrows and icons
                                colorPrimary: '#42c9c4',       // Active/selected date color
                                controlItemBgActive: '#42c9c4',// Selected cell background
                                controlItemBgHover: '#3a4557', // Hover effect on dates
                            },

                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: "'Poppins', sans-serif"
                        },
                    }}
                >
                    <AntdDatePicker
                        ref={reference}
                        className='form-control config_filed'
                        placeholder={placeholder}
                        format={'DD/MM/YYYY'}
                        name={name}
                        value={value ? dayjs(value, 'DD/MM/YYYY') : ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
